"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNotifications = exports.getNotificationsById = exports.getNotifications = exports.getFilters = exports.deleteNotifications = exports.defaultNotificationsData = exports.createNotifications = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultNotificationsData = exports.defaultNotificationsData = {
  id: 0,
  enabled: true,
  title: '',
  message: '',
  params: null,
  image: null,
  link: null,
  page: null,
  sendToAll: false,
  appVersion: null,
  platform: null,
  employeeId: [],
  employeeRoleId: [],
  employeeRole: [],
  divisionId: [],
  zoneId: [],
  regionId: [],
  zmLocationId: [],
  amLocationId: [],
  mrLocationId: [],
  isVisible: true,
  sendUploadImage: false,
  appOpened: '',
  utmSource: '',
  utmCampaign: '',
  utmMedium: '',
  type: '',
  isDeletable: true
};
const getNotifications = params => (0, _request.default)({
  url: '/notifications',
  method: 'get',
  params
});
exports.getNotifications = getNotifications;
const getNotificationsById = id => (0, _request.default)({
  url: `/notifications/${id}`,
  method: 'get'
});
exports.getNotificationsById = getNotificationsById;
const updateNotifications = (id, data) => (0, _request.default)({
  url: `/notifications/${id}`,
  method: 'patch',
  data
});
exports.updateNotifications = updateNotifications;
const deleteNotifications = id => (0, _request.default)({
  url: `/notifications/${id}`,
  method: 'delete'
});
exports.deleteNotifications = deleteNotifications;
const createNotifications = data => (0, _request.default)({
  url: '/notifications/',
  method: 'post',
  data
});
exports.createNotifications = createNotifications;
const getFilters = data => (0, _request.default)({
  url: '/notifications/fetch',
  method: 'post',
  data
});
exports.getFilters = getFilters;